<template>
<div v-if="list && list.length">
    <bread-crumb :vector="[{fa : ' تخفیف های ویژه امروز در فروشگاه '+supplierName,path : '/Category/'+route.params.supplier_id}]" v-if="supplierName"/>
    <section class="sc-o27kl3-0 gsZmuC product-slider-section mt-5">
        <div class="sc-d8w7bo-1 jpdybm">
            <div class="d-flex flex-wrap" style="padding-inline: 3px;gap: 1px;">
                <product-border :list="list" />
            </div>
        </div>
    </section>
</div>
<Loading v-else page="group" />
</template>
<script setup>
import {ref,defineProps} from 'vue'
import { useRoute } from 'vue-router';
import ProductBorder from '@/components/section/item/ProductBorder.vue';
import BreadCrumb from '@/components/section/item/BreadCrumb.vue';
import Loading from "../../../../section/item/loading.vue";

const route = useRoute()
let list = ref([]);
let supplierName = ref('');
getItems()
async function getItems(){
let response = await fetch('https://radap.ir/Backend/api/section/pages/store/whole_damp.php?id='+route.params.supplier_id)
let data = await response.json()
    list.value = data.items;
    supplierName.value = data.supplier_name;
    window.scrollTo(0,0)
}
</script>
